var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{class:`${_vm.type}-list-item gap-[16px]`},[_c('CoralCircle',[_c('Centered',[_c('span',{staticClass:"text-[15px] font-medium text-white font-bold"},[_vm._v("\n        "+_vm._s(_vm.num)+"\n      ")])])],1),_vm._v(" "),_c('div',{class:`pl-4 list-item-text-${_vm.type}`},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }